export default {
	FETCH_DOCUMENTS: 'FETCH_DOCUMENTS',
	SEARCH_DOCUMENTS: 'SEARCH_DOCUMENTS',

	FETCH_PROJECTEN: 'FETCH_PROJECTEN',
	SEARCH_PROJECTS: 'SEARCH_PROJECTS',
	FETCH_PROJECT_DETAIL: 'FETCH_PROJECT_DETAIL',

	FETCH_REFERENCES: 'FETCH_REFERENCES',
	FETCH_FAQ: 'FETCH_FAQ',
	FETCH_FAQ_BY_ID: 'FETCH_FAQ_BY_ID',
	FETCH_TESTIMONIES: 'FETCH_TESTIMONIES',
	FETCH_CATEGORIES: 'FETCH_CATEGORIES',
	SEARCH_CATEGORIES: 'SEARCH_CATEGORIES',
	FETCH_PRODUCTS: 'FETCH_PRODUCTS',
	FETCH_PRODUCT_BY_SLUG: 'FETCH_PRODUCT_BY_SLUG',
	FETCH_USERS: 'FETCH_USERS',

	SEARCH_ATEX: 'SEARCH_ATEX',

	FETCHING_FAILED: 'FETCHING_FAILED',
	FETCHING_SUCCEEDED: 'FETCHING_SUCCEEDED',
	FETCHING_IN_PROGRESS: 'FETCHING_IN_PROGRESS',

	// external actions
	REMOVE_DOCUMENT: 'REMOVE_DOCUMENT',
	REMOVE_REFERENCE: 'REMOVE_REFERENCE',
	REMOVE_PROJECT: 'REMOVE_PROJECT',
	REMOVE_FAQ: 'REMOVE_FAQ',

	REMOVE_FAQ_ITEM: 'REMOVE_FAQ_ITEM',
};



// WEBPACK FOOTER //
// ./src/redux/content/actionTypes.js